import { render } from "./ServiceDetailsModal.vue?vue&type=template&id=da3856d8&scoped=true"
import script from "./ServiceDetailsModal.vue?vue&type=script&lang=js"
export * from "./ServiceDetailsModal.vue?vue&type=script&lang=js"

import "./ServiceDetailsModal.vue?vue&type=style&index=0&id=da3856d8&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da3856d8"]])

export default __exports__